export const listenVoice = {
  en: "Listen to your recording",
  hi: "अपनी रिकॉर्डिंग सुनें",
  or: "अपनी रिकॉर्डिंग सुनें"
};

export const clear = {
  en: "Are you able to hear it clearly?",
  hi: "क्या आप इसे स्पष्ट रूप से सुन पा रहे हैं?",
  or: "क्या आप इसे स्पष्ट रूप से सुन पा रहे हैं?"
};

export const yes = {
  en: "Yes",
  hi: "हाँ",
  or: "ହଁ"
};

export const no = {
  en: "No",
  hi: "नहीं",
  or: "ନା"
};

export const startRecording = {
  en: "Click to start recording",
  hi: "रिकॉर्डिंग शुरू करने के लिए क्लिक करें",
  or: "रिकॉर्डिंग शुरू करने के लिए क्लिक करें"
};
